module.exports = __webpack_public_path__ + "media/faq-change-location.5c3cb395.mp4";